<template>
    <q-layout view="hHh lpR fFf">
        <q-header  v-if="logueado">
            <q-toolbar style="min-height:60px">
                <q-btn flat dense round @click="irInicio" style="background:rgba(255,255,255,.12)">
                    <q-icon name="mdi-home" color="white" size="23px" />
                </q-btn>
                <q-toolbar-title>
                    <span style="font-size:16px;font-weight:500;letter-spacing:.01em">
                        AUTOCONTA   
                        </span>
                    </q-toolbar-title>
                <div class="rfc-chip" style="font-size:16px;">{{ $store.state.usuario.rfc }}</div>

                <q-btn flat round dense class="header-btn" @click="drawerEmpresas = !drawerEmpresas">
                    <q-icon name="mdi-domain" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Empresas</q-tooltip>
                </q-btn>

                <q-btn flat round dense class="header-btn" @click="drawerPerfil = !drawerPerfil">
                    <q-icon name="mdi-account" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Perfil</q-tooltip>
                </q-btn>
            </q-toolbar>
        </q-header>

<!-- DRAWER DERECHO -->
<q-drawer :width="320" v-model="drawerPerfil" behavior="mobile" side="right" bordered v-if="logueado"
            style="background:#fff">
            <drawerPerfil />
        </q-drawer>

    <!-- DRAWER EMPRESAS -->
    <q-drawer :width="320" v-model="drawerEmpresas" behavior="mobile" side="right" bordered v-if="logueado"
                style="background:#fff">
                <drawerEmpresas />
            </q-drawer>

        <!-- DRAWER IZQUIERDO -->
        <q-drawer v-model="leftDrawerOpen" show-if-above :mini="miniState" @mouseover="miniState = false"
            @mouseout="miniState = true" :width="320" :breakpoint="500" bordered content-class="bg-purple-1">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list padding>

                    <!-- <q-item active clickable v-ripple @click="irEstadoCostoProduccionVenta">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-factory" />
                        </q-item-section>
                        <q-item-section>
                            Estado de costo producción y venta
                        </q-item-section>
                    </q-item> -->

                    <q-separator />

                    <q-item active clickable v-ripple @click="irDepreciacion">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-trending-down" />
                        </q-item-section>
                        <q-item-section>
                            Depreciación
                        </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irCalculoAjusteAnualInflacion">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-calculator-variant-outline" />
                        </q-item-section>
                        <q-item-section>
                            Cálculo ajuste anual por Inflación
                        </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irProvisionalesIva">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-database-arrow-up-outline" />
                        </q-item-section>
                        <q-item-section>
                            Provisonales de IVA
                        </q-item-section>
                    </q-item>
                    <q-separator />

                    <q-item active clickable v-ripple @click="irProvisionalesIsr">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-cash-plus" />
                        </q-item-section>
                        <q-item-section>
                            Provisionales de ISR
                        </q-item-section>
                    </q-item>
                    <q-separator />

                    <!-- <q-item active clickable v-ripple @click="irConciliacionContableFiscal">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-text-box-search-outline" />
                        </q-item-section>
                        <q-item-section>
                            Concialiación contable fiscal
                        </q-item-section>
                    </q-item>

                    <q-separator /> -->

                    <q-item active clickable v-ripple @click="irDiot">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-brightness-percent" />
                        </q-item-section>
                        <q-item-section>
                            DIOT
                        </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irDiot2025">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-brightness-percent" />
                        </q-item-section>
                        <q-item-section>
                            DIOT 2025
                        </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irFlujoEfectivo">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-cash-sync" />
                        </q-item-section>
                        <q-item-section>
                            Flujo de efectivo
                        </q-item-section>
                    </q-item>

                    <q-separator />

                    <q-item active clickable v-ripple @click="irDevolucionesIva">
                        <q-item-section avatar>
                            <q-icon size="sm" name="mdi-file-percent" />
                        </q-item-section>
                        <q-item-section>
                            Devoluciones de IVA
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>

        <q-footer style="height: 30px;" bordered class="bg-dark text-white">
            <q-toolbar>
                <q-toolbar-title>
                </q-toolbar-title>
            </q-toolbar>
        </q-footer>
    </q-layout>
</template>

<script>
import { ref } from 'vue'
import axios from "axios";
import drawerPerfil from "../DrawerPerfil/DrawerPerfil.vue"
import drawerEmpresas from '../DrawerEmpresas/DrawerEmpresas.vue'


export default {

    name: 'MainLayout',
    components: {
        drawerPerfil, drawerEmpresas
    },
    data() {
        return {
            drawerPerfil: false,
            isDarkMode: false,
            leftDrawerOpen: false,
            drawer: false,
            miniState: true,
            drawerEmpresas: false,
        }
    },

    watch: {
        isDarkMode(val) {
            this.$q.dark.set(val);
        }
    },
    computed: {
        logueado() {
            return this.$store.state.usuario;
        },
        token() { 
            return this.$store.state.empresaStore 
        },

    },
    created() {
    },
    methods: {
        irInicio() {
            this.$router.push({ name: 'Home' })
        },
        irCalculoAjusteAnualInflacion() {
            this.$router.push({ name: 'CalculoAjusteAnualInflacion' })
        },
        irConciliacionContableFiscal() {
            this.$router.push({ name: 'ConciliacionContableFiscal' })
        },
        irDepreciacion() {
            this.$router.push({ name: 'Depreciacion' })
        },
        irDevolucionesIva() {
            this.$router.push({ name: 'DevolucionesIva' })
        },
        irDiot() {
            this.$store.state.listDiotStore = []
            this.$router.push({ name: 'Diot' })
        },
        irDiot2025() {
            this.$store.state.listDiotStore = []
            this.$router.push({ name: 'Diot2025' })
        },
        irEstadoCostoProduccionVenta() {
            this.$router.push({ name: 'EstadoCostoProduccionVenta' })
        },
        irFlujoEfectivo() {
            this.$router.push({ name: 'FlujoEfectivo' })
        },
        irProvisionalesIsr() {
            this.$router.push({ name: 'ProvisionalesIsr' })
        },
        irProvisionalesIva() {
            this.$router.push({ name: 'ProvisionalesIva' })
        },
    }
}
</script>
